import { put, call, takeLatest } from 'redux-saga/effects';
import client from '../client';
import * as supportActions from '../reducers/support';

export function* submitSupportForm({payload: { data, res, rej } }) {
  try {
    const response = yield call(client, {
      url: 'support/submit',
      method: 'post',
      data,
      credentials: 'include',
    });

    yield put(supportActions.submitSupportFormSuccess(response));
    if (typeof res === 'function') {
      yield call(res, response);
    }
  } catch (err) {
    yield put(supportActions.submitSupportFormFail(err));
    if (typeof rej === 'function') {
      yield call(rej, err);
    }
  }
}

export default function* supportSaga() {
  yield takeLatest(supportActions.submitSupportForm, submitSupportForm);
}
